// workerApi.ts
import AxiosInstanceCreator from 'services/api';
import {
  ReqWorkerList,
  ReqWorkerSafetyHistory,
  ReqWorkersNotInSafetyTraining,
  ResWorkerDetail,
  ResWorkers,
  ResWorkerSafetyHistories,
  WorkerInfo,
  WorkerSafetyHistory
} from '../model/worker.model';
import { AxiosInstance } from 'axios';
import { BaseApiResponse, ReqGetUserDetail, UserCombinedInfo } from 'modules';

const workerInstance = new AxiosInstanceCreator().create();

export const workerApi = {
  /**
   * 작업자 조회 (Worker 전용)
   */
  async getWorkers(query: string): Promise<ResWorkers> {
    return workerInstance.get(`/worker?${query}`).then((res) => res.data);
  },

  /**
   * 작업자/관리자 조회
   */
  async getWorkersAdmins(query: string): Promise<ResWorkers> {
    return workerInstance.get(`/worker/all?${query}`).then((res) => res.data);
  },

  /**
   * 안전교육 필터링 조회
   */
  async getWorkersBySafetyId(safetyId: string, query: string): Promise<ResWorkers> {
    return workerInstance.get(`/worker/all/${safetyId}?${query}`).then((res) => res.data);
  },

  // /**
  //  * 작업자 등록
  //  */
  // async postWorker(formData: FormData): Promise<ResultResponse<WorkerDetail, null>> {
  //   const res = await workerInstance.post('', formData, {
  //     headers: {
  //       'Content-Type': 'multipart/form-data'
  //     }
  //   });
  //   return res.data;
  // },

  /**
   * 작업자 상세 조회
   */
  async getWorkerDetail(id: string): Promise<ResWorkerDetail> {
    return workerInstance.get(`/worker/${id}`).then((res) => res.data);
  },

  /**
   * 작업자 파일 다운로드
   */
  async getWorkerDownloadAPI(fileId: string): Promise<string> {
    const res = await workerInstance.get(`/worker/downloads/${fileId}`, {
      headers: {
        'Content-Type': 'image/jpeg;charset=UTF-8, application/octet-stream; charset=UTF-8'
      },
      responseType: 'blob'
    });

    const imageURL = URL.createObjectURL(res.data);
    return imageURL;
  },

  /**
   * 안전교육 이력 조회
   */
  async getWorkerSafetyHistories(
    workerId: string,
    query: string
  ): Promise<ResWorkerSafetyHistories> {
    return workerInstance.get(`/worker/${workerId}/safety?${query}`).then((res) => res.data);
  }
};

export class WorkerAPI {
  Axios: AxiosInstance;

  constructor() {
    this.Axios = new AxiosInstanceCreator().create();
  }

  /** 작업자 목록 조회 API */
  async getWorkerList(params: ReqWorkerList): Promise<BaseApiResponse<unknown, WorkerInfo>> {
    return await this.Axios.get<BaseApiResponse<unknown, WorkerInfo>>('/worker', { params }).then(
      (res) => res.data
    );
  }

  /** 작업자 상세 정보 조회 API */
  async getWorkerDetail(data: ReqGetUserDetail): Promise<BaseApiResponse<UserCombinedInfo>> {
    return await this.Axios.get<BaseApiResponse<UserCombinedInfo>>(`/worker/${data.userId}`).then(
      (res) => res.data
    );
  }

  /** 작업자 안전교육 이력 조회 API */
  async getWorkerSafetyHistory(
    params: ReqWorkerSafetyHistory
  ): Promise<BaseApiResponse<unknown, WorkerSafetyHistory>> {
    return await this.Axios.get<BaseApiResponse<unknown, WorkerSafetyHistory>>(
      `/worker/${params.workerId}/safety`,
      { params }
    ).then((res) => res.data);
  }

  /** 작업자/관리자 목록 전체 조회 API */
  async getWorkerAndAdminList(
    params: ReqWorkerList
  ): Promise<BaseApiResponse<unknown, WorkerInfo>> {
    return await this.Axios.get<BaseApiResponse<unknown, WorkerInfo>>('/worker/all', {
      params
    }).then((res) => res.data);
  }

  /** 안전교육에 참여하지 않은 사용자 목록 조회 API */
  async getWorkersNotInSafetyTraining(
    params: ReqWorkersNotInSafetyTraining
  ): Promise<BaseApiResponse<unknown, WorkerInfo>> {
    return await this.Axios.get<BaseApiResponse<unknown, WorkerInfo>>(`/all/${params.safetyId}`, {
      params
    }).then((res) => res.data);
  }

  /** 작업자 파일 다운로드 API */
  async downloadWorkerFile(fileId: string): Promise<Blob> {
    return await this.Axios.get<Blob>(`/downloads/${fileId}`, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'image/jpeg;charset=UTF-8, application/octet-stream; charset=UTF-8'
      }
    }).then((res) => res.data);
  }
}
